import { buildProps as e, definePropType as r } from "./index601.js";
import { mutable as i } from "./index612.js";
import { isNumber as p } from "./index565.js";
import { isString as m, isArray as n } from "./index575.js";
import { CHANGE_EVENT as s, UPDATE_MODEL_EVENT as a } from "./index584.js";
const t = (o) => p(o) || m(o) || n(o), u = e({
  /**
   * @description whether to activate accordion mode
   */
  accordion: Boolean,
  /**
   * @description currently active panel, the type is `string` in accordion mode, otherwise it is `array`
   */
  modelValue: {
    type: r([Array, String, Number]),
    default: () => i([])
  },
  /**
   * @description set expand icon position
   */
  expandIconPosition: {
    type: r([String]),
    default: "right"
  },
  /**
   * @description before-collapse hook before the collapse state changes. If `false` is returned or a `Promise` is returned and then is rejected, will stop collapsing
   */
  beforeCollapse: {
    type: r(
      Function
    )
  }
}), y = {
  [a]: t,
  [s]: t
};
export {
  y as collapseEmits,
  u as collapseProps,
  t as emitChangeFn
};
